var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcCart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  d: "M7.559 7.624a.167.167 0 0 1 .161-.207h15.693c.109 0 .188.102.162.207l-2.245 8.918a.17.17 0 0 1-.162.126H9.966a.17.17 0 0 1-.162-.126z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2.212 3.22a.75.75 0 1 0 0 1.5H3.48l.073-.004 2.466.003 2.33 9.134 2.275 2.897-3.23-12.833a.92.92 0 0 0-.896-.695H3.54l-.06-.002z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  d: "M12.896 22.02a1.78 1.78 0 0 1-1.788 1.772 1.78 1.78 0 0 1-1.789-1.771c0-.973.796-1.771 1.789-1.771a1.78 1.78 0 0 1 1.788 1.77ZM22.312 22.02a1.78 1.78 0 0 1-1.789 1.772 1.78 1.78 0 0 1-1.788-1.771c0-.973.795-1.771 1.788-1.771a1.78 1.78 0 0 1 1.788 1.77Z"
})));
export default SvgIcCart;